<div class="ds-flex ds-flex-col ds-relative">
  <div class="ds-mb-lg ds-mt-sm">
    <div class="ds-border-b-[1px] ds-border-tertiary-lightergrey ds-relative">
      <div
        class="
          ds-absolute ds-bg-background-white
          -ds-top-[16px]
          ds-right-[calc(50%-14px)] ds-px-2xs
        "
      >
        <span class="ds-icons-off before:!ds-bg-secondary-red"></span>
      </div>
    </div>
  </div>
  <message-group alignment="left" class="ds-bg-background-green">
    {{ message.message }}
    <message-timestamp
      *ngIf="message.timestamp"
      [timestamp]="message.timestamp"
      class="ds-text-secondary-green"
    ></message-timestamp>
    <div>
      <p class="ds-text-xs ds-py-sm">
        {{ chatAppDownloadHistoryLabel }}
      </p>
      <button
        *ngIf="chatAppDownloadHistoryButtonLabel"
        class="ds-button ds-button-primary ds-tiny ds-no-arrow"
        (click)="onDownloadHistory()"
      >
        <span class="ds-icon ds-icon-download"></span>
        {{ chatAppDownloadHistoryButtonLabel }}
      </button>
    </div>
  </message-group>
</div>
